export function approvalStatusClass(status) {
  switch (status) {
    case "approved":
      return "bg-green-200 text-green-800";
    case "to_be_approved":
      return "bg-yellow-200 text-yellow-800";
    case "refused":
      return "bg-red-200 text-red-800";
    default:
      return "bg-gray-200 text-gray-600";
  }
}
